"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.placements = exports.eventsForTrigger = exports.arrowShadowBlur = exports.arrowSize = void 0;
var arrowBaseSize = 20;
var arrowSize = {
  base: arrowBaseSize,
  side: arrowBaseSize / Math.SQRT2,
  height: arrowBaseSize / 2
};
exports.arrowSize = arrowSize;
var arrowShadowBlur = 4;
exports.arrowShadowBlur = arrowShadowBlur;
var eventsForTrigger = {
  // should this be mousedown instead? If so, useClickOutside
  // would have to be changed to listen to mousedown as well.
  click: {
    click: 'toggle'
  },
  hover: {
    mouseenter: 'show',
    mouseleave: 'hide',
    focus: 'show',
    blur: 'hide'
  }
}; // prettier-ignore

exports.eventsForTrigger = eventsForTrigger;
var placements = ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'auto', 'auto-start', 'auto-end'];
exports.placements = placements;